
export const colorList = {
    pros: '#DDF8DF',
    cons: '#FFD6D6',
    navBar: '#2c5FFE',
    fontColor:'#666666',
    textColor: '#0D0D0D',
    brandColor: '#4D78FE',
    activeTextColor: '#2c5FFE',
    backGroundColor: '#fafafa',
    dashBoardnavBar: '#FFFFFF',
    indexPresenceColor: '#EBEBEB'



}

